export default function DragIndicatorIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path d="M17.2 40.65q-1.6 0-2.725-1.125T13.35 36.8q0-1.6 1.125-2.7T17.2 33q1.6 0 2.7 1.1t1.1 2.7q0 1.6-1.1 2.725t-2.7 1.125Zm13.65 0q-1.6 0-2.725-1.125T27 36.8q0-1.6 1.125-2.7T30.85 33q1.55 0 2.675 1.1 1.125 1.1 1.125 2.7t-1.125 2.725Q32.4 40.65 30.85 40.65ZM17.2 27.8q-1.6 0-2.725-1.125T13.35 24q0-1.6 1.125-2.7t2.725-1.1q1.6 0 2.7 1.1T21 24q0 1.55-1.1 2.675-1.1 1.125-2.7 1.125Zm13.65 0q-1.6 0-2.725-1.125T27 24q0-1.6 1.125-2.7t2.725-1.1q1.55 0 2.675 1.1 1.125 1.1 1.125 2.7 0 1.55-1.125 2.675Q32.4 27.8 30.85 27.8ZM17.2 15q-1.6 0-2.725-1.125T13.35 11.15q0-1.55 1.125-2.675Q15.6 7.35 17.2 7.35t2.7 1.125Q21 9.6 21 11.15q0 1.6-1.1 2.725T17.2 15Zm13.65 0q-1.6 0-2.725-1.125T27 11.15q0-1.55 1.125-2.675Q29.25 7.35 30.85 7.35q1.55 0 2.675 1.125Q34.65 9.6 34.65 11.15q0 1.6-1.125 2.725T30.85 15Z" />
    </svg>
  );
}
